import { apiRequest } from './client';
import type { CombatActionType, CombatLogResponse, CombatState } from '../types';

export function fetchCombat(gameId: number) {
  return apiRequest<CombatState>(`/api/games/${gameId}/combat`, { auth: true });
}

export function fetchCombatLog(gameId: number) {
  return apiRequest<CombatLogResponse>(`/api/games/${gameId}/combat/log`, { auth: true });
}

export function startCombat(
  gameId: number,
  characterIds: number[],
  gameNpcIds: number[],
  foeCharacterIds: number[] = [],
) {
  return apiRequest<CombatState>(`/api/games/${gameId}/combat`, {
    method: 'POST',
    auth: true,
    body: {
      character_ids: characterIds,
      game_npc_ids: gameNpcIds,
      foe_character_ids: foeCharacterIds,
    },
  });
}

export function addCombatParticipants(
  gameId: number,
  characterIds: number[],
  gameNpcIds: number[],
  foeCharacterIds: number[] = [],
) {
  return apiRequest<CombatState>(`/api/games/${gameId}/combat/participants`, {
    method: 'POST',
    auth: true,
    body: {
      character_ids: characterIds,
      game_npc_ids: gameNpcIds,
      foe_character_ids: foeCharacterIds,
    },
  });
}

export function executeCombatAction(
  gameId: number,
  payload: {
    actor_id: number;
    action: CombatActionType;
    target_ids: number[];
    spell_id?: number;
    item_id?: number;
    ability_name?: string;
  }
) {
  return apiRequest<CombatState>(`/api/games/${gameId}/combat/actions`, {
    method: 'POST',
    auth: true,
    body: payload,
  });
}

export function endCombat(gameId: number) {
  return apiRequest<CombatState>(`/api/games/${gameId}/combat/end`, {
    method: 'POST',
    auth: true,
  });
}

export function fleeCombatParticipant(gameId: number, participantId: number) {
  return apiRequest<CombatState>(
    `/api/games/${gameId}/combat/participants/${participantId}/flee`,
    { method: 'POST', auth: true },
  );
}